// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".domain-list-domain-list-930fe .icloud-ui-pro-table{padding:24px}.domain-list-domain-list-930fe .icloud-ui-pro-table .ant-table-cell .ant-btn:not(:first-child){margin-left:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"domain-list": "domain-list-domain-list-930fe",
	"domainList": "domain-list-domain-list-930fe"
};
export default ___CSS_LOADER_EXPORT___;
